export default __webpack_public_path__ + "static/media/jsIcon.4757a9a2.svg";